/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination1OfSalarySystemListedAdminDto } from '../models/Pagination1OfSalarySystemListedAdminDto';
import type { PostPutSalarySystemAdminRequest } from '../models/PostPutSalarySystemAdminRequest';
import type { SalarySystemAdminDto } from '../models/SalarySystemAdminDto';
import type { SalarySystemType } from '../models/SalarySystemType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SalarySystemsService {
    /**
     * **Required Policy:** `ManageSalarySystem`
     * @returns SalarySystemAdminDto OK
     * @throws ApiError
     */
    public static postSalarySystemAdmin({
        requestBody,
    }: {
        requestBody?: PostPutSalarySystemAdminRequest,
    }): CancelablePromise<SalarySystemAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/salarysystems',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSalarySystems`
     * @returns Pagination1OfSalarySystemListedAdminDto OK
     * @throws ApiError
     */
    public static getSalarySystemsAdmin({
        name,
        type,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        name?: string,
        type?: SalarySystemType,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfSalarySystemListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/salarysystems',
            query: {
                'name': name,
                'type': type,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSalarySystemDetails`
     * @returns SalarySystemAdminDto OK
     * @throws ApiError
     */
    public static getSalarySystemAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<SalarySystemAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/salarysystems/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSalarySystem`
     * @returns SalarySystemAdminDto OK
     * @throws ApiError
     */
    public static putSalarySystemAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutSalarySystemAdminRequest,
    }): CancelablePromise<SalarySystemAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/salarysystems/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
